import React from 'react';
import { motion } from 'framer-motion';

function AuthLogo() {
   return (
      <motion.div
         initial={{ opacity: 0, scale: 0.8 }}
         animate={{ opacity: 1, scale: 1 }}
         transition={{ duration: 0.5, delay: 0.1 }}
         className="text-center mb-8"
      >
         <h1 className="text-6xl font-display text-pearl">QUILL STUDIO</h1>
         <p className="mt-2 text-silver font-mono text-xs tracking-widest">
            CRAFT YOUR NARRATIVE UNIVERSE
         </p>
      </motion.div>
   );
}

export default AuthLogo;
